import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "lib/apiInstance";
import { LOCAL_STORAGE } from "utils/constant";
import { BASE_URL } from "./endpoints";

export const feedbackService = createApi({
  reducerPath: "feedbackService",
  baseQuery: baseQueryWithReauth({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem(LOCAL_STORAGE.USER_TOKEN) || "";
      headers.set("Content-type", "application/json; charset=UTF-8");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["feedback"],
  endpoints: (builder) => ({
    getAllFeedbacks: builder.query({
      query: (params) => ({
        url: "/admin/feedback/get",
        method: "GET",
        params,
      }),
      providesTags: ["feedback"],
    }),
    updateFeedbackStatus: builder.mutation({
      query: ({ feedbackId, status }) => ({
        url: `/admin/feedback/status/${feedbackId}`,
        method: "PATCH",
        body: { status },
      }),
      invalidatesTags: ["feedback"],
    }),
    deleteFeedback: builder.mutation({
      query: (feedbackId) => ({
        url: `/admin/feedback/delete/${feedbackId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["feedback"],
    }),
  }),
});

export const {
  useGetAllFeedbacksQuery,
  useUpdateFeedbackStatusMutation,
  useDeleteFeedbackMutation,
} = feedbackService;
export default feedbackService;
